export const auth = {
    methods : {
        checkUser : function () {
            if (localStorage.getItem('ghost.user') && localStorage.getItem('ghost.userToken')) {
                this.user = JSON.parse(localStorage.getItem('ghost.user'));
                this.userToken = localStorage.getItem('ghost.userToken');
                this.axios.defaults.headers.common.Authorization = 'bearer ' + this.userToken;
            } else {
                this.logout();
            }
        },
        logout : function () {
            // log them out and redirect to login screen
            this.$root.logout();
        }
    },
    mounted : function () {
        this.checkUser();
    }
}